import React from 'react';
import Logo from './Logo';
import { Heart, Phone, MessageCircle, Mail, MapPin, Globe } from 'lucide-react';
import { contact } from '../mock';

const LeafBorder = () => (
  <div className="flex items-center justify-center gap-3 py-6">
    <svg viewBox="0 0 60 20" className="w-32 h-5" fill="none">
      <path d="M2 12 Q15 2, 28 12 T58 12" stroke="#8fa05a" strokeWidth="1" />
      <path d="M10 12 c-1 -4, 4 -7, 8 -5" fill="#a8b870" />
      <path d="M40 12 c-1 -4, 4 -7, 8 -5" fill="#a8b870" />
    </svg>
    <Heart size={14} className="text-[#8fa05a] fill-[#cfe0a8]" />
    <svg viewBox="0 0 60 20" className="w-32 h-5" fill="none">
      <path d="M2 12 Q15 2, 28 12 T58 12" stroke="#8fa05a" strokeWidth="1" />
      <path d="M12 12 c1 -4, -4 -7, -8 -5" fill="#a8b870" />
      <path d="M42 12 c1 -4, -4 -7, -8 -5" fill="#a8b870" />
    </svg>
  </div>
);

const Footer = () => {
  return (
    <footer className="bg-[#f0e9d2] pt-14 pb-6 relative">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Logo size={52} />
            <p className="text-[#3d4a36] text-sm mt-5 leading-relaxed max-w-xs">
              Compassionate, confidential mental wellness sessions to help you heal, grow and live a more peaceful life.
            </p>
            <div className="mt-4 flex items-center gap-2 text-sm text-[#3a5232]">
              <Globe size={14} />
              <a href={`https://${contact.website}`} className="hover:text-[#7a8a4c] font-medium">{contact.website}</a>
            </div>
          </div>
          <div>
            <h4 className="font-serif text-lg text-[#2c3f25] mb-3">Explore</h4>
            <ul className="space-y-2 text-sm text-[#3d4a36]">
              <li><a href="#home" className="hover:text-[#7a8a4c] transition-colors">Home</a></li>
              <li><a href="#about" className="hover:text-[#7a8a4c] transition-colors">About</a></li>
              <li><a href="#services" className="hover:text-[#7a8a4c] transition-colors">Services</a></li>
              <li><a href="#expect" className="hover:text-[#7a8a4c] transition-colors">What to expect</a></li>
              <li><a href="#contact" className="hover:text-[#7a8a4c] transition-colors">Contact</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-serif text-lg text-[#2c3f25] mb-3">Reach Santhosha</h4>
            <ul className="space-y-3 text-sm text-[#3d4a36]">
              <li className="flex items-center gap-2">
                <Phone size={14} className="text-[#3a5232]" />
                <a href={`tel:${contact.phone}`} className="hover:text-[#7a8a4c]">{contact.phone}</a>
              </li>
              <li className="flex items-center gap-2">
                <MessageCircle size={14} className="text-[#3a5232]" />
                <a href={`https://wa.me/91${contact.whatsapp}`} className="hover:text-[#7a8a4c]">WhatsApp</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={14} className="text-[#3a5232]" />
                <a href={`mailto:${contact.email}`} className="hover:text-[#7a8a4c] break-all">{contact.email}</a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-serif text-lg text-[#2c3f25] mb-3">Visit Us</h4>
            <div className="flex items-start gap-2 text-sm text-[#3d4a36] leading-relaxed">
              <MapPin size={16} className="text-[#3a5232] shrink-0 mt-0.5" />
              <p>
                {contact.address.line1}<br />
                {contact.address.line2}<br />
                {contact.address.city}
              </p>
            </div>
          </div>
        </div>

        <LeafBorder />

        <p className="text-center text-[#3d4a36] text-sm md:text-base italic">
          {contact.tagline}
        </p>

        <div className="border-t border-[#e5dcc0] mt-8 pt-5 flex flex-col md:flex-row items-center justify-between gap-2">
          <p className="text-xs text-[#7a8a4c]">© {new Date().getFullYear()} Natural Care. All rights reserved.</p>
          <p className="text-xs text-[#7a8a4c]">Nurturing Minds, Enriching Lives</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
